import { DropdownItem } from '@shared/components/dropdown/dropdown.component';
import { DateTime } from 'luxon';

export type SelectedFilter = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
    type: MultiSelectId[];
    status: MultiSelectId[];
    endsInMonths: MultiSelectId;
    responsible: MultiSelectId[];
    categories: MultiSelectId[];
    areas: MultiSelectId[];
    customers: MultiSelectId[];
    counterparts: MultiSelectId[];
    typeOfInventory: MultiSelectId[];
    manufacturer: MultiSelectId[];
    inventoryusers: MultiSelectId[];
    listTypes: MultiSelectId[];
    dateRange: { from: DateTime | null; to: DateTime | null };
};

export type FilterData = {
    type: MultiSelectItem[];
    status: MultiSelectItem[];
    endsInMonths: DropdownItem<number>[];
    //responsible: MultiSelectItem[];
    categories: MultiSelectItem[];
    areas: MultiSelectItem[];
    customers: MultiSelectItem[];
    counterparts: MultiSelectItem[];
    typeOfInventory: MultiSelectItem[];
    manufacturer: MultiSelectItem[];
    inventoryusers: MultiSelectItem[];
    listTypes: MultiSelectItem[];
    dateRange: { from: DateTime | null; to: DateTime | null };
};

export type Fields =
    | 'type'
    | 'status'
    | 'endsInMonths'
    | 'responsible'
    | 'categories'
    | 'areas'
    | 'typeOfInventory'
    | 'manufacturer'
    | 'inventoryusers'
    | 'customers'
    | 'counterparts'
    | 'listTypes';

export type FilterConfig = {
    fields: Fields[];
};

export const EMPTY_FILTER: SelectedFilter = {
    type: [],
    status: [],
    endsInMonths: -1,
    responsible: [],
    categories: [],
    areas: [],
    customers: [],
    counterparts: [],
    typeOfInventory: [],
    manufacturer: [],
    inventoryusers: [],
    dateRange: {
        from: null,
        to: null
    },
    listTypes: []
};
